/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://hkt56yitkh.execute-api.ca-central-1.amazonaws.com/campusvr",
            "region": "ca-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://46qjctjhurf5xondog3gysxl2m.appsync-api.ca-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "ca-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cognito_identity_pool_id": "ca-central-1:6708e0c1-97ce-4f8d-9fd1-4c14bb48a598",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_1rv0gQ8Em",
    "aws_user_pools_web_client_id": "3vr08fnpsso0d9bm8ojs2o2ltv",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "CUSTOM:INSTITUTION_ID"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "ctagsapp95313-campusvr",
    "aws_user_files_s3_bucket_region": "ca-central-1",
    "aws_cognito_login_mechanisms": [
        "PREFERRED_USERNAME"
    ]
};


export default awsmobile;
